import "./otherCategories.scss";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import { I18nContext } from "../../i18n";

const OtherCategories = () => {
	const { categories } = useContext(AppContext);
	const { translate, langCode } = useContext(I18nContext);

	return (
		<ul className="other-categories">
			<h3 className="other-categories__title">
				{translate("otherCategories").toUpperCase()}
			</h3>
			{categories
				.filter((item) => item.parent === 0)
				.map((category, index) => (
					<li key={index} className="other-categories__item">
						<Link to={`/${langCode}/category/${category.slug}`}>
							{translate("categories")?.[category.slug]}
						</Link>
					</li>
				))}
		</ul>
	);
};

export default OtherCategories;
